"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Paragraph = function Paragraph(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "body1" : _ref$variant,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "primary" : _ref$color,
      _ref$text = _ref.text,
      text = _ref$text === void 0 ? "" : _ref$text;
  return /*#__PURE__*/_react.default.createElement(_Typography.default, {
    component: "p",
    color: color,
    variant: variant
  }, text);
};

var _default = Paragraph;
exports.default = _default;
Paragraph.propTypes = {
  /** Text */
  text: _propTypes.default.string,

  /** Text Color */
  color: _propTypes.default.oneOf(["initial", "inherit", "primary", "secondary", "textPrimary", "textSecondary", "error"]),

  /** The variants */
  variant: _propTypes.default.oneOf(["body1", "body2"])
};